/**
 * Zone definitions for pickup and delivery cost management.
 *
 * Each zone has:
 * - id: The unique identifier used in the database/API
 * - code: The zone code number/letter (may be shared across zone types)
 * - name: The display name shown to users in the UI
 */
export const ZONES = [
  { id: 'M', code: 'M', name: 'Metro' },
  { id: 'C1', code: '1', name: 'Country Zone 1' },
  { id: 'C2', code: '2', name: 'Country Zone 2' },
  { id: 'C3', code: '3', name: 'Country Zone 3' },
  { id: 'R1', code: '1', name: 'Regional Zone 1' },
  { id: 'R3', code: '3', name: 'Regional Zone 3' },
  { id: 'R4', code: '4', name: 'Regional Zone 4' },
  { id: 'R4A', code: '4', name: 'Regional Zone 4A' },
  { id: 'R4B', code: '4', name: 'Regional Zone 4B' },
  { id: 'R5', code: '5', name: 'Regional Zone 5' },
  { id: 'RM2', code: '2', name: 'Remote Zone 2' },
  { id: 'RM4', code: '4', name: 'Remote Zone 4' },
  { id: 'RM5', code: '5', name: 'Remote Zone 5' },
  { id: 'RM6', code: '6', name: 'Remote Zone 6' },
  { id: 'RM7', code: '7', name: 'Remote Zone 7' },
  { id: 'RM8', code: '8', name: 'Remote Zone 8' },
] as const;

export type ZoneId = (typeof ZONES)[number]['id'];

/**
 * Get the display name for a zone id.
 * Returns the id itself if no matching zone is found.
 */
export function getZoneName(id: string): string {
  const zone = ZONES.find((z) => z.id === id);
  return zone?.name ?? id;
}

/**
 * Get the zone code for a zone id.
 * Returns the id itself if no matching zone is found.
 */
export function getZoneCode(id: string): string {
  const zone = ZONES.find((z) => z.id === id);
  return zone?.code ?? id;
}

/**
 * Zone options formatted for use in select dropdowns.
 * Each option has a `value` (unique id) and `label` (display name).
 */
export const ZONE_OPTIONS = ZONES.map((zone) => ({
  value: zone.id,
  label: zone.name,
}));
